// Registro mínimo del service worker (PWA instalable). Sin Workbox: SW propio
// en public/sw.js. Solo se registra en producción.

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    const url = `${process.env.PUBLIC_URL}/sw.js`;
    navigator.serviceWorker.register(url).catch((err) => {
      console.error('SW registration failed:', err);
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
